import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class VisualizadorRouterService
{
    constructor(private router: Router) {}
}
